'use strict';

var FaresSurchargeUploadController = function FaresSurchargeUploadController($scope, dataRetrieverService, faresSurchargeUploadService, dataRetrieverConstantsService) {
  var gridId = 'fares-surcharge-upload-grid';
  $scope.isImportValidationError = false;
  $scope.isErrorLogShown = false;
  $scope.errorLogData = {};
  $scope.screen = 'system-conf-user-defined-ref-data-market';
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.SURCHARGE_UPLOAD_MODE).setCustomSearchCriteriaRules([]);
  function save(rows) {
    return faresSurchargeUploadService.saveConfigurationMarketClassSurcharges(rows);
  }
  $scope.saveChanges = function (event, rows) {
    save(rows).then(function () {
      $scope.$broadcast('fares-surcharge-upload:saveSuccess');
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.isErrorGridVisible = function () {
    return $scope.isErrorLogShown;
  };
  $scope.removeRows = function (event, selectedRows) {
    faresSurchargeUploadService.removeMarketClassSurcharges(selectedRows).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.exportToCSV = function (event, loadedData) {
    faresSurchargeUploadService.exportMarketClassSurcharges(gridId, loadedData);
  };
};
FaresSurchargeUploadController.$inject = ['$scope', 'DataRetrieverService', 'FaresSurchargeUploadService', 'DataRetrieverConstantsService'];
module.exports = FaresSurchargeUploadController;